import React, { type ComponentType, type PropsWithChildren } from 'react';

import type { JSONValue, PluginCollection } from '@atlassiansox/cross-flow-base-types/types';

import { CrossFlowProvider } from './lib/CrossFlowProvider';
import { type AnalyticsWebClientInterface, type MaybePromise } from './lib/types';

export { useCrossFlow, withCrossFlow, Journeys, Targets, Reasons } from './index';

interface StartProps {
	analyticsClient: MaybePromise<AnalyticsWebClientInterface>;
	cloudId?: string;
	globalExperimentalOptions?: Record<string, JSONValue>;
	locale: string;
	plugins?: PluginCollection;
}

export const StartProvider: ComponentType<PropsWithChildren<StartProps>> = (props) => {
	return <CrossFlowProvider {...props} originProduct="start" />;
};

export default StartProvider;
